import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {Venue} from '@emm/core/models/venue.model';
import {standardRetry} from '@emm/core/util/rx.util';
import {Consumer} from '@emm/core/models/consumer.model';
import {MenuDateUtil} from '@emm/core/util/menu-date.util';
import {ItemSummary} from '@emm/core/models/item-summary.model';


@Injectable({ providedIn: 'root' })
export class VenueService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {
    }

    getVenuesByLocation(location: string): Observable<Venue[]> {
        return this.http
            .get(`${this.apiUrl}/venues/${location}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }

    getConsumersByVenue(venueId: string | number): Observable<Consumer[]> {
        return this.http
            .get(`${this.apiUrl}/venues/consumers/${venueId}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }

    getVenueMenu(location: string, venueNumber: string | number, effectiveDate?: string): Observable<any> {
        effectiveDate = MenuDateUtil.formatDateToMidnight(effectiveDate);
        return this.http
            .get(`${this.apiUrl}/menu/v4/${location}/${venueNumber}?effectiveDate=${encodeURIComponent(effectiveDate)}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }

    getMenuItemForVenue(consumer: string, location: string, venueNumber: string | number, path?: string,
                        effectiveDate?: string): Observable<any> {
        effectiveDate = MenuDateUtil.formatDateToMidnight(effectiveDate);
        return this.http
            .get(`${this.apiUrl}/menu/v4/${consumer}/${location}/${venueNumber}/item?path=${encodeURIComponent(path)}&effectiveDate=${encodeURIComponent(effectiveDate)}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }

       getMenuItemChildrenForVenue(consumer: string, location: string, venueNumber: string | number, path?: string,
                                effectiveDate?: string): Observable<ItemSummary[]> {
        const tagPath = path ? path : '/';
        effectiveDate = MenuDateUtil.formatDateToMidnight(effectiveDate);
        return this.http
            .get(`${this.apiUrl}/menu/v4/${consumer}/${location}/${venueNumber}/item/children?path=${tagPath}&effectiveDate=${effectiveDate}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }
}
